import { Command } from 'common/design-system/components-v2';
import styled from 'styled-components';

export const CommandSnippet = styled(Command)`
    white-space: break-spaces;
    max-height: 390px;
    overflow: scroll;
`;
